    document.addEventListener("DOMContentLoaded", function () {

        const botoes = document.querySelectorAll(".section-nevegue-times .box-right .box-item[id]");
        const conteudos = document.querySelectorAll(".section-nevegue-times .box-conteudo");

        if (!botoes.length || !conteudos.length) return;

        // inicia ou recalcula o slick
        function iniciarSlick($container) {

            const $slick = $container.find('.slick-vitrine');

            // se não existir slick nessa aba
            if (!$slick.length) return;

            // inicia apenas uma vez
            if (!$slick.hasClass('slick-initialized')) {

                $slick.slick({
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $container.find('.prev-arrow'),
                    nextArrow: $container.find('.next-arrow'),
                    dots: false,
                    adaptiveHeight: false,
                    responsive: [
                        {
                            breakpoint: 1201,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 651,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });

            } else {

                // recalcula largura quando exibir novamente
                $slick.slick('setPosition');

            }
        }

        function resetar() {
            botoes.forEach(btn => btn.classList.remove("active"));
            conteudos.forEach(ct => ct.classList.remove("active"));
        }

        function ativar(id) {

            const botao = document.getElementById(id);
            const conteudo = document.getElementById("conteudo-" + id);

            if (!botao || !conteudo) return;

            botao.classList.add("active");
            conteudo.classList.add("active");

            // pequeno delay para o display:flex aplicar
            setTimeout(() => {
                iniciarSlick($(conteudo));
            }, 50);
        }

        // clique nas abas
        botoes.forEach(btn => {

            btn.addEventListener("click", function () {

                const id = this.id;

                resetar();
                ativar(id);

            });

        });

        // inicia a primeira aba ativa
        const primeiroAtivo = document.querySelector(
            ".section-nevegue-times .box-right .box-item.active"
        );

        if (primeiroAtivo) {
            ativar(primeiroAtivo.id);
        }

    });